import * as React from "react";
import "./styles.scss"

export enum TAB_NAMES {
    CURRENT = "Current",
    HISTORY = "History",
}

interface ToolBarTabsProps {
    tabsNames: TAB_NAMES[];
    onTabSelected?: (tabName: TAB_NAMES) => () => void;
    getTabText?: (tabName: TAB_NAMES) => string;
    currentTab: TAB_NAMES;
}

export const ToolBarTabs: React.FC<ToolBarTabsProps> = ({onTabSelected, currentTab, tabsNames, getTabText}) => {


    return (
        <div className={"toolbar-tab-container"}>{tabsNames.map(
            name => <Tab
                text={getTabText(name)}
                tabName={name}
                onTabSelected={onTabSelected}
                isActive={name === currentTab}
                key={name}
            />)}</div>
    );
};


const Tab = ({text, tabName, onTabSelected, isActive}: {
    text: string,
    tabName: TAB_NAMES,
    onTabSelected: (TAB_NAMES: string) => () => void,
    isActive: boolean
}) => {
    return (
        <div className={`toolbar-tab ${isActive ? "active" : ""}`} onClick={onTabSelected(tabName)}>
            {text}
        </div>
    )
}